import { render, staticRenderFns } from "./UpgradeUnavailable.vue?vue&type=template&id=152bd80a&scoped=true&"
import script from "./UpgradeUnavailable.vue?vue&type=script&lang=js&"
export * from "./UpgradeUnavailable.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeUnavailable.vue?vue&type=style&index=0&id=152bd80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bd80a",
  null
  
)

export default component.exports